<!-- Project: GSSC Pilot Front-end -->
<!-- Filename: Register.vue -->
<!-- Copyright European Space Agency, 2020 -->
<!-- This file is part of the source code package for contract PO 5001024866 -->
<!-- No part of the package, including this file, may be copied, modified,   -->
<!-- propagated, or distributed without prior approval by ESA.               -->
<template>
  <div>
    <div class="col-lg-3"></div>
    <div class="container register col-lg-6 col-sm-12">
      <div class="row justify-content-md-center justify-content-center">
        <article class="col-10 center">
          <h2>Registration</h2>
          <hr />
          <h4>GSSC Now’s Preview Program is Open!</h4>
          <p>Be one of the first to get the latest updates and experience new features early.</p>
          <h4>What do we offer?:</h4>
          <ul>
            <li>Early access to our system and feedback systems for you to share your thoughts and suggestions;</li>
            <li>Computing and storage resources to do your GNSS magic;</li>
          </ul>
          <h4>What do you need?:</h4>
          <ul>
            <li>Your enthusiasm in GNSS and Science;</li>
            <li>Your opinion, in the shape of requests for new features, improvements or fix;</li>
            <li>
              Your request, completing our application form
              <a
                href="https://gssc.esa.int/register/"
              >here</a>.
            </li>
          </ul>
        </article>
        <div class="col-1">
          <button type="button" class="close" aria-label="Close" @click="$router.push('/')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    </div>
    <div class="col-lg-3"></div>
    <!-- <form>
      <p>
        <label for="username">User Name</label>
        <input id="username" name="username" type="text" />
      </p>
      <p>
        <label for="password">Password</label>
        <input id="password" name="password" type="password" />
      </p>
      <button type="submit">Log In</button>
    </form>-->
  </div>
</template>

<script>
export default {
  name: 'login',
  // data() {
  //   return {
  //     wpData,
  //   }
  // },
  mounted() {
    this.$emit('finishLoading')
  },
}
</script>

<style lang="scss" scoped>
.register {
  background-color: #fff;
  margin: 30px auto;
  border: 1px solid #eee;
  padding: 20px;
  box-shadow: 0 2px 3px #ccc;
}
</style>
